var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.width > 0 && _vm.height > 0)?_c('VueDraggableResizable',{class:{
    draggable: true,
    isDragging: _vm.dragging
  },style:({
    transform: ("translate(" + (-1 * _vm.x) + "px," + (-1 * _vm.y) + "px)")
  }),attrs:{"resizable":false,"grid":[_vm.GRID,_vm.GRID],"x":_vm.x - _vm.DRAG_WIDTH,"y":_vm.y - _vm.DRAG_WIDTH,"drag-handle":".drag"},on:{"dragging":_vm.onMove,"dragstop":_vm.onStop}},[_c('div',{staticClass:"drag top",style:({
    width: (_vm.width + "px"),
    height: ((_vm.DRAG_WIDTH + _vm.OVERRAPPING) + "px")
  })}),_c('div',{staticClass:"drag bottm",style:({
    top: ((_vm.height - _vm.DRAG_WIDTH - _vm.OVERRAPPING) + "px"),
    width: (_vm.width + "px"),
    height: ((_vm.DRAG_WIDTH + _vm.OVERRAPPING) + "px")
  })}),_c('div',{staticClass:"drag left",style:({
    top: ((_vm.DRAG_WIDTH + _vm.OVERRAPPING) + "px"),
    width: ((_vm.DRAG_WIDTH + _vm.OVERRAPPING) + "px"),
    height: ((_vm.height - _vm.DRAG_WIDTH * 2 - _vm.OVERRAPPING * 2) + "px")
  })}),_c('div',{staticClass:"drag right",style:({
    top: ((_vm.DRAG_WIDTH + _vm.OVERRAPPING) + "px"),
    left: ((_vm.width - _vm.DRAG_WIDTH - _vm.OVERRAPPING) + "px"),
    width: ((_vm.DRAG_WIDTH + _vm.OVERRAPPING) + "px"),
    height: ((_vm.height - _vm.DRAG_WIDTH * 2 - _vm.OVERRAPPING * 2) + "px")
  })})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }